import React from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import "./Testimonial.css";

const testimonials = [
  {
    name: "Puja Thorat",
    role: "Prof.Puja Thorat, Sanjivani Group",
    quote:
      "Pratik has done an outstanding job in developing the website for Sanjivani Group. His creativity, technical expertise, and dedication have truly brought our vision to life. We deeply appreciate his professionalism and commitment to quality.",
    image: "https://media.licdn.com/dms/image/v2/D4D35AQGVDcDVBvSaZw/profile-framedphoto-shrink_200_200/profile-framedphoto-shrink_200_200/0/1696761657602?e=1755928800&v=beta&t=4fU9bkywMbDFLHDLcKC5yI8Ob1fG5lC5iy1kTc3ksds"
  },
  {
    name: "Dr. Mangesh Deshpande",
    role: "Co-Founder and CTO - Athang Robotics",
    quote:
      "Pratik successfully developed a robust and user-friendly web application for Athnag Robotics. His innovative approach, attention to detail, and ability to understand our requirements made the project a great success. We are highly satisfied with his work.",
    image: "https://media.licdn.com/dms/image/v2/C4E03AQHQv-ZgKS6kWw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1597915875219?e=1758153600&v=beta&t=FwBhyC7e_3WHbbHfd08eIqmZxSseJGE-IpXpSgiK518"
  },
  {
    name: "jamie Tendem",
    role: "Uk Based Client",
    quote:
      "Pratik designed and developed a professional website for my language services, and also assisted me with improvements on my other projects. His support, communication, and technical skills were exceptional, making the whole process smooth and reliable",
    image: "https://media.licdn.com/dms/image/v2/D5603AQFy__h0Zmhb5w/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1698974607540?e=1758153600&v=beta&t=Dyk4smbAUY822aTfJ0pK4GndizIsCmQcieAlwJV0UIg"
  },
 
];

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  pauseOnHover: true
};

const Testimonial = () => {
  return (
    <section className="testimonial-section py-5 bg-white text-dark">
      <Container>
        <h2 className="text-center fw-bold mb-4 display-5">What Clients Say</h2>
        <Slider {...settings}>
          {testimonials.map((testimonial, idx) => (
            <div key={idx} className="testimonial-slide text-center px-3">
              <div className="testimonial-card mx-auto p-4 shadow rounded bg-light">
                <FaQuoteLeft size={30} className="text-primary mb-3" />
                <p className="lead fst-italic text-muted mb-4">
                  "{testimonial.quote}"
                </p>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="rounded-circle mb-3"
                  style={{ width: "80px", height: "80px", objectFit: "cover" }}
                />
                <h5 className="fw-bold mb-1">{testimonial.name}</h5>
                <p className="text-secondary mb-0">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default Testimonial;
